module.exports = __webpack_public_path__ + "static/img/icon_list_bullet.1ff1920.png";